import styled from 'styled-components';
import { LineChart } from '../../Charts/LineChart/LineChart';
import HoverPopover from '../../HoverPopover/HoverPopover';
import { themeColor } from '../../theme/colors';
import { smRegular } from '../../theme/typography';

export const FunctionBehaviorChartContainer = styled.div`
  flex: 1;
`;

export const FunctionsLineChart = styled(LineChart)`
  transform: translateY(-40px);
`;

export const FunctionMetricsContainer = styled.div`
  ${smRegular}
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FunctionMetric = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const FunctionMetricDot = styled.div<{
  color?: string;
  size?: number;
}>`
  background: ${({ color }) => color ?? themeColor('turquoise')};
  width: ${({ size }) => size || 10}px;
  height: ${({ size }) => size || 10}px;
  border-radius: 100%;
`;

export const FunctionMetricTitle = styled.div`
  color: ${themeColor('textTertiary')};
  width: 7ch;

  display: flex;
  align-items: center;
  gap: 4px;
`;

export const EndpointsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ReferenceIndicatorPopover = styled(HoverPopover)`
  overflow: unset;
`;

export const DeploymentsList = styled.div`
  display: flex;
  flex-direction: column;

  gap: 8px;
`;
